import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=385959fe&scoped=true&"
import script from "./Jumbotron.vue?vue&type=script&lang=js&"
export * from "./Jumbotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385959fe",
  null
  
)

export default component.exports